import React from 'react';
import { useLocation } from 'react-router-dom';

import dataFooterMenu from '../../data/footer/footerMenu';

const FooterMenu = () => {
    const { pathname } = useLocation();
    const showScrollToTop = pathname === '/' || pathname === '/services' || pathname.startsWith('/service/');
    const scrollToTop = () => window.scrollTo({
        top: 0,
        left: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
    return (
        <nav className="menu-secondary" aria-label="Social links">
            <ul className="nav">
                {dataFooterMenu && dataFooterMenu.map((item, key) => {
                    return (
                        <li key={key} className="nav-item">
                            <a title={item.title} aria-label={item.title} href={item.link} target='_blank' rel="noreferrer"><i className={item.icon} aria-hidden="true"></i></a>
                        </li>
                    );
                })}
                {showScrollToTop && <li className="nav-item rg-back-to-top-item">
                    <button type="button" className="rg-back-to-top" onClick={scrollToTop} aria-label="Back to top" title="Back to top">
                        <i className="fas fa-arrow-up" aria-hidden="true"></i>
                    </button>
                </li>}
            </ul>
        </nav>
    );
};

export default FooterMenu;
